/*
 * @Description: 视频中心pc端骨架屏
 * @Author: liuzhezhe
 * @Date: 2023-06-29 13:38:47
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-07-06 10:16:03
 */
import React, { useState, useEffect } from 'react'
import styles from './list.scss'

const VideoList = (props) => {
  const [state] = useState([1, 2, 3, 4, 5, 6, 7, 8])

  useEffect(() => {

  }, [])

  return (
    <div className={styles['order-skeletons']}>
      {state.map(item => (
        <div className={styles['order-item']} key={item}>
          <div className={styles['skeletons']}></div>
          <div className={styles['skeletons']}></div>
          <div className={styles['skeletons']}></div>
        </div>
      ))}
    </div>
  )
}

export default VideoList
